import type { OptionItemWithChildren } from "@/api/admin";
import type { TreeDataItem } from "@/components/tree-view";

export function mapToTreeData(items: OptionItemWithChildren[]): TreeDataItem[] {
  return items?.map(item => ({
    id: item.id,
    name: item.name,
    children: item.children ? mapToTreeData(item.children) : undefined,
  }));
}

// Helper function to check if an ID exists in the tree recursively
export const isIdInTree = (
  id: string | undefined,
  tree: TreeDataItem[]
): boolean => {
  if (!id) return false;
  for (const item of tree) {
    if (item.id === id) return true;
    if (item.children && isIdInTree(id, item.children)) return true;
  }
  return false;
};
